import Spin from 'spinjs'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export const DEFAULT = 'default'
export const TINY = 'tiny'

const sizes = {
  tiny: {
    lines: 10,
    radius: 6,
    width: 2,
    length: 5,
    speed: 1.6,
    trail: 45
  },
  default: {
    lines: 12,
    radius: 11,
    speed: 1.6,
    width: 3,
    trail: 50,
    length: 8
  }
}

export default class Spinner extends Component {
  static propTypes = {
    size: PropTypes.oneOf([DEFAULT, TINY]).isRequired,
    spinning: PropTypes.bool.isRequired,
    style: PropTypes.object
  }

  static defaultProps = {
    spinning: false,
    size: DEFAULT
  }

  shouldComponentUpdate(nextProps) {
    const { spinning } = this.props
    return spinning !== nextProps.spinning
  }

  componentDidMount() {
    const { size, spinning } = this.props
    this.spinner = new Spin(sizes[size])

    if (spinning) {
      this.start()
    }
  }

  componentDidUpdate() {
    const { spinning } = this.props
    spinning ? this.start() : this.stop()
  }

  componentWillUnmount() {
    this.stop()
    this.spinner = null
  }

  start() {
    if (!this.spinner) {
      return
    }
    this.spinner.spin(findDOMNode(this))
  }

  stop() {
    if (!this.spinner) {
      return
    }
    this.spinner.stop()
  }

  render() {
    const { style } = this.props
    const defaultStyle = {
      top: '50%',
      left: '50%',
      position: 'absolute'
    }

    const computedStyle = Object.assign({}, defaultStyle, style)

    return <div style={computedStyle} />
  }
}



// WEBPACK FOOTER //
// ../src/components/Spinner.js